(() => {
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), summary, [tabindex]:not([tabindex="-1"])';

  class EpDrawer extends HTMLElement {
    connectedCallback() {
      if (this.parentElement !== document.body) {
        document.querySelectorAll(`body > ep-drawer#${this.id}`).forEach((el) => el !== this && el.remove());
        document.body.appendChild(this);
        return;
      }
      if (this.bound) return;
      this.bound = true;
      this.panel = this.querySelector('.ep-drawer__panel');
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-ep-drawer-close]')) this.close();
      });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
        if (e.key === 'Tab') this.trap(e);
      });
      window.matchMedia('(min-width: 990px)').addEventListener('change', (mq) => mq.matches && this.close());
    }

    open(trigger) {
      this.trigger = trigger;
      this.hidden = false;
      document.documentElement.classList.add('ep-lock');
      document.querySelectorAll('[data-ep-drawer-open]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        this.panel.focus({ preventScroll: true });
      });
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      document.documentElement.classList.remove('ep-lock');
      document.querySelectorAll('[data-ep-drawer-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      if (this.trigger) this.trigger.focus({ preventScroll: true });
    }

    trap(e) {
      const items = [...this.panel.querySelectorAll(FOCUSABLE)].filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }
  if (!customElements.get('ep-drawer')) customElements.define('ep-drawer', EpDrawer);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ep-drawer-open]');
    if (!btn) return;
    const drawer = document.getElementById(btn.getAttribute('aria-controls'));
    if (drawer && drawer.open) {
      e.preventDefault();
      drawer.open(btn);
    }
  });

  const noHover = window.matchMedia('(hover: none)');

  function initMega(root) {
    root.querySelectorAll('[data-ep-mega]').forEach((item) => {
      if (item.dataset.epBound) return;
      item.dataset.epBound = '1';
      const link = item.querySelector('.ep-nav__link');
      let timer;
      const set = (open) => {
        clearTimeout(timer);
        item.classList.toggle('is-open', open);
        link.setAttribute('aria-expanded', String(open));
        if (open) {
          item.parentElement.querySelectorAll('[data-ep-mega].is-open').forEach((other) => other !== item && other.dispatchEvent(new CustomEvent('ep:close')));
        }
      };
      item.addEventListener('ep:close', () => set(false));
      item.addEventListener('mouseenter', () => {
        clearTimeout(timer);
        timer = setTimeout(() => set(true), 90);
      });
      item.addEventListener('mouseleave', () => {
        clearTimeout(timer);
        timer = setTimeout(() => set(false), 160);
      });
      item.addEventListener('focusin', () => set(true));
      item.addEventListener('focusout', (e) => {
        if (!item.contains(e.relatedTarget)) set(false);
      });
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && item.classList.contains('is-open')) {
          set(false);
          link.focus();
        }
      });
      link.addEventListener('click', (e) => {
        if (noHover.matches && !item.classList.contains('is-open')) {
          e.preventDefault();
          set(true);
        }
      });
    });
  }

  initMega(document);
  document.addEventListener('shopify:section:load', (e) => initMega(e.target));
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-ep-mega]')) {
      document.querySelectorAll('[data-ep-mega].is-open').forEach((item) => item.dispatchEvent(new CustomEvent('ep:close')));
    }
  });
})();
